import React from 'react';
import PropTypes from 'prop-types';
import SwitchOn from '@/assets/tick.svg';
import SwitchOff from '@/assets/close.svg';
import cx from '@/utils/cx';
import useStyle from './style';

const Switch = ({
  validation,
  formatter,
  value,
  _color,
  onValue,
  offValue,
  disabled,
  onChange,
  ...rest
}) => {
  const classes = useStyle({ _color });

  const isOn = value === onValue;

  const toggleValue = () => {
    if (!disabled) {
      onChange(isOn ? offValue : onValue);
    }
  };
  const clickHandler = () => {
    toggleValue();
  };
  const keyboardHandler = (event) => {
    if (event.keyCode === 32) {
      toggleValue();
    }
  };

  return (
    <div
      role="switch"
      className={cx(classes.switch, isOn ? 'on' : 'off')}
      onClick={clickHandler}
      tabIndex="0"
      onKeyDown={(event) => event.preventDefault()}
      onKeyUp={keyboardHandler}
      aria-checked={isOn}
      {...(disabled ? { disabled: true } : {})}
      {...rest}
    >
      <div className="circle">
        { isOn ? <SwitchOn /> : <SwitchOff /> }
      </div>
    </div>
  );
};

Switch.propTypes = {
  _color: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  onValue: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  offValue: PropTypes.any,
  disabled: PropTypes.bool,
};

Switch.defaultProps = {
  _color: 'primary',
  onValue: true,
  offValue: false,
  disabled: false,
};

export default Switch;
